import { render } from "./ScoreEdit.vue?vue&type=template&id=58f235c4&scoped=true"
import script from "./ScoreEdit.vue?vue&type=script&lang=js"
export * from "./ScoreEdit.vue?vue&type=script&lang=js"

import "./ScoreEdit.vue?vue&type=style&index=0&id=58f235c4&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f235c4"]])

export default __exports__